/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';

/**
 * 
 * @export
 * @interface ExcludedPosition
 */
export interface ExcludedPosition {
    /**
     * 
     * @type {string}
     * @memberof ExcludedPosition
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludedPosition
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludedPosition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludedPosition
     */
    symbol?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof ExcludedPosition
     */
    assetClass?: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof ExcludedPosition
     */
    assetType?: AssetType;
    /**
     * 
     * @type {number}
     * @memberof ExcludedPosition
     */
    currentExposure: number;
}



/**
 * Check if a given object implements the ExcludedPosition interface.
 */
export function instanceOfExcludedPosition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "currentExposure" in value;

    return isInstance;
}

export function ExcludedPositionFromJSON(json: any): ExcludedPosition {
    return ExcludedPositionFromJSONTyped(json, false);
}

export function ExcludedPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludedPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'description': json['description'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'assetClass': !exists(json, 'asset_class') ? undefined : AssetClassFromJSON(json['asset_class']),
        'assetType': !exists(json, 'asset_type') ? undefined : AssetTypeFromJSON(json['asset_type']),
        'currentExposure': json['current_exposure'],
    };
}

export function ExcludedPositionToJSON(value?: ExcludedPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'sc_id': value.scId,
        'description': value.description,
        'symbol': value.symbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'current_exposure': value.currentExposure,
    };
}

